// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"80518c39","203":"7ba6331d","277":"5b029578","386":"75c7b346","466":"5e153ac5","593":"bdcdd2cd","758":"e91cd5d1","862":"ac8e8583"}[chunkId] + ".chunk.js";
};